import React, { useEffect, useState } from 'react';
interface PriceDisplayProps {
  amount: number;
  originalAmount?: number;
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  lightText?: boolean;
}
export function PriceDisplay({
  amount,
  originalAmount,
  className = '',
  size = 'lg',
  lightText = false
}: PriceDisplayProps) {
  const [currency, setCurrency] = useState('USD');
  const [locale, setLocale] = useState('en-US');
  useEffect(() => {
    const userLocale = navigator.language || 'en-US';
    setLocale(userLocale);
    const localeLower = userLocale.toLowerCase();
    if (localeLower.includes('gb')) {
      setCurrency('GBP');
    } else if (['de', 'fr', 'it', 'es-es', 'nl', 'pt'].some(l => localeLower.includes(l))) {
      setCurrency('EUR');
    } else {
      setCurrency('USD');
    }
  }, []);
  const formatPrice = (val: number) => {
    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        minimumFractionDigits: val % 1 === 0 ? 0 : 2
      }).format(val);
    } catch (e) {
      // Fallback if locale formatting fails
      const symbol = currency === 'EUR' ? '€' : currency === 'GBP' ? '£' : '$';
      return `${symbol}${val}`;
    }
  };
  const sizeClasses = {
    sm: 'text-xl',
    md: 'text-2xl',
    lg: 'text-4xl md:text-5xl',
    xl: 'text-5xl md:text-7xl'
  };
  const originalSizeClasses = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-xl md:text-2xl',
    xl: 'text-2xl md:text-3xl'
  };
  return <div className={`flex items-center justify-center gap-3 md:gap-4 ${className}`} data-id="element-343">
      {originalAmount && <span className={`text-red-600 line-through font-medium ${originalSizeClasses[size]}`} data-id="element-344">
          {formatPrice(originalAmount)}
        </span>}
      <span className={`font-bold font-heading ${sizeClasses[size]} ${lightText ? 'text-white' : 'text-navy-900'}`} data-id="element-345">
        {formatPrice(amount)}
      </span>
    </div>;
}